// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fG","advertDetailHeaderLocation__value":"c-m_fH"};